export const flexColumnSx = {
  flex: '1 1 0',
  minHeight: 0,
  overflow: 'hidden',
};

export const flexItemSx = {
  minHeight: 0,
  display: 'flex',
  overflow: 'hidden',
};

export const cardSx = {
  display: 'flex',
  flexDirection: 'column',
  py: 1,
  px: 1.5,
  minHeight: 0,
  overflow: 'hidden',
};

export const cardContentSx = {
  minHeight: 0,
};

export const scrollableCardContentSx = {
  flex: '1 1 0',
  minHeight: 0,
  overflow: 'auto',
};
